import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../components/sections/Hero";
import EditorialMarquee from "../components/sections/EditorialMarquee";
import Editorial from "../components/sections/Editorial";
import Projects from "../components/sections/Projects";
import HowItWorks from "../components/sections/HowItWorks";
import Principles from "../components/sections/Principles";
import Contact from "../components/sections/Contact";

export default function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const id = hash.replace("#", "");
    const el = document.getElementById(id);
    if (el) {
      setTimeout(() => {
        if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
        else el.scrollIntoView({ behavior: "smooth" });
      }, 200);
    }
  }, [hash]);

  return (
    <div data-testid="home-page">
      <Hero />
      <EditorialMarquee />
      <Editorial />
      <Projects />
      <HowItWorks />
      <Principles />
      <Contact />
    </div>
  );
}
